
export class GetUserConfig {
  static readonly type = '[User Config] - Get user config';
}

export class SetPendingNotifications {
  static readonly type = '[User Config] - Set pending notifications';
  constructor(public pendingNotifications: boolean) {}
}